import { DateTime } from 'luxon';

export const newsDateString = (date: string, node_locale: string) => {
  return DateTime.fromISO(date)
    .setLocale(node_locale)
    .toLocaleString({ month: 'long', day: 'numeric', year: 'numeric' });
};
export const dateRangeMed = (from: string, to: string, node_locale: string) => {
  if (DateTime.fromISO(from).hasSame(DateTime.fromISO(to), 'day')) {
    return DateTime.fromISO(from)
      .setLocale(node_locale)
      .toLocaleString(DateTime.DATE_MED);
  }
  return `${
    DateTime.fromISO(from).year === DateTime.fromISO(to).year
      ? DateTime.fromISO(from)
          .setLocale(node_locale)
          .toLocaleString({ month: 'short', day: 'numeric' })
      : DateTime.fromISO(from)
          .setLocale(node_locale)
          .toLocaleString(DateTime.DATE_MED)
  }
        -  
        ${DateTime.fromISO(to)
          .setLocale(node_locale)
          .toLocaleString(DateTime.DATE_MED)}
        `;
};

export const dateRangeLPO = (
  from: string,
  to: string,
  node_locale: string,
  fromTextString?: string,
  untilTextString?: string,
) => {
  if (from === 'Invalid DateTime' || !from) {
    return `${untilTextString} ${DateTime.fromISO(to)
      .setLocale(node_locale)
      .toLocaleString(DateTime.DATE_MED)}`;
  }
  if (to === 'Invalid DateTime' || !to) {
    return `${fromTextString} ${DateTime.fromISO(from)
      .setLocale(node_locale)
      .toLocaleString(DateTime.DATE_MED)}`;
  }

  if (DateTime.fromISO(from).hasSame(DateTime.fromISO(to), 'day')) {
    return DateTime.fromISO(from)
      .setLocale(node_locale)
      .toLocaleString(DateTime.DATE_MED);
  }

  return `${
    DateTime.fromISO(from).year === DateTime.fromISO(to).year
      ? DateTime.fromISO(from)
          .setLocale(node_locale)
          .toLocaleString({ month: 'short', day: 'numeric' })
      : DateTime.fromISO(from)
          .setLocale(node_locale)
          .toLocaleString(DateTime.DATE_MED)
  }
        -  
        ${DateTime.fromISO(to)
          .setLocale(node_locale)
          .toLocaleString(DateTime.DATE_MED)}`;
};

export const LocalizedTime = (time: string, node_locale: string) => {
  const tempDate = `1970-01-01T${time}`;
  const options: Intl.DateTimeFormatOptions = {
    hour: '2-digit',
    minute: '2-digit',
  };
  const localizedTime = new Date(tempDate).toLocaleTimeString(
    node_locale,
    options,
  );
  return localizedTime;
};
